import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { DEFAULT_THEME, DEFAULT_CONTENT, DEFAULT_NAV, DEFAULT_SEO, DEFAULT_CHECKOUT, applyTheme } from "../lib/theme";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(DEFAULT_THEME);
  const [settings, setSettings] = useState(null);
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [nav, setNav] = useState(DEFAULT_NAV);
  const [seo, setSeo] = useState(DEFAULT_SEO);
  const [checkout, setCheckout] = useState(DEFAULT_CHECKOUT);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(() => {
    return api.get("/settings").then((r) => {
      setSettings(r.data);
      const t = { ...DEFAULT_THEME, ...(r.data.theme || {}) };
      setTheme(t);
      applyTheme(t);
      setContent({ ...DEFAULT_CONTENT, ...(r.data.content || {}) });
      setNav(Array.isArray(r.data.nav) && r.data.nav.length ? r.data.nav : DEFAULT_NAV);
      setSeo({ ...DEFAULT_SEO, ...(r.data.seo || {}) });
      setCheckout({ ...DEFAULT_CHECKOUT, ...(r.data.checkout || {}) });
    }).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <ThemeContext.Provider value={{ theme, settings, content, nav, seo, checkout, loaded, refresh }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
